export function scrollToMessageElement(messageId: number): boolean {
  const target = document.getElementById(`msg-${messageId}`);
  if (!target) return false;

  const bubble =
    target.querySelector<HTMLElement>("[data-message-bubble]") ?? target;

  target.scrollIntoView({ behavior: "smooth", block: "center" });
  bubble.classList.remove("animate-highlight");
  void bubble.offsetWidth;
  bubble.classList.add("animate-highlight");
  window.setTimeout(() => bubble.classList.remove("animate-highlight"), 1500);
  return true;
}
